import s from './input-group.module.scss'
import cx from 'classnames'

type Props = {
  children: React.ReactNode
  containerClassName?: string
  errorMessage?: string
}

export const InputGroupV3 = ({
  children,
  errorMessage,
  containerClassName,
}: Props) => {
  return (
    <div className={cx(s.inputGroup, containerClassName)}>
      {children}
      {!!errorMessage && <p className={s.error}>{errorMessage}</p>}
    </div>
  )
}
